module.exports = __webpack_public_path__ + "img/stackslash-20-mobile.fd3eed06.jpg";